import { gql } from '@apollo/client';
import blocks from '../wp-blocks';

export const EditorBlocks = gql`
  ${blocks.CoreGroup.fragments.entry}
  ${blocks.CoreColumns.fragments.entry}
  ${blocks.CoreColumn.fragments.entry}
  ${blocks.CoreImage.fragments.entry}
  ${blocks.CoreParagraph.fragments.entry}
  ${blocks.CoreCode.fragments.entry}
  ${blocks.CoreButtons.fragments.entry}
  ${blocks.CoreButton.fragments.entry}
  ${blocks.CoreQuote.fragments.entry}
  ${blocks.CoreSeparator.fragments.entry}
  ${blocks.CoreList.fragments.entry}
  ${blocks.CoreHeading.fragments.entry}
  ${blocks.CoreCover.fragments.entry}
  ${blocks.CoreTable.fragments.entry}
  ${blocks.AcfCard.fragments.entry}
  ${blocks.AcfAccordion.fragments.entry}
  ${blocks.AcfFeature.fragments.entry}
  ${blocks.AcfBillboard.fragments.entry}
  ${blocks.AcfLeadGenForm.fragments.entry}
  ${blocks.AcfLogoFarm.fragments.entry}
  ${blocks.AcfStyledList.fragments.entry}
  ${blocks.AcfStats.fragments.entry}
  ${blocks.AcfProductComparisonCard.fragments.entry}
  ${blocks.AcfFeatureComparison.fragments.entry}
  ${blocks.AcfTabs.fragments.entry}
  ${blocks.AcfArtDirectionImage.fragments.entry}
  ${blocks.AcfShadow.fragments.entry}
  ${blocks.AcfAppBadges.fragments.entry}
  ${blocks.AcfStripe.fragments.entry}
  ${blocks.AcfCarousel.fragments.entry}
  ${blocks.AcfLottie.fragments.entry}
  ${blocks.AcfExpandableCard.fragments.entry}
  ${blocks.AcfContainer.fragments.entry}
  ${blocks.AcfForm.fragments.entry}
  ${blocks.AcfInput.fragments.entry}
  ${blocks.AcfSelect.fragments.entry}
  ${blocks.AcfFieldset.fragments.entry}
  ${blocks.AcfFilteredList.fragments.entry}
  ${blocks.AcfFilteredListItem.fragments.entry}
  fragment AllBlocks on EditorBlock {
    name
    __typename
    renderedHtml
    id: clientId
    parentId: parentClientId
    ...${blocks.CoreGroup.fragments.key}
    ...${blocks.CoreColumns.fragments.key}
    ...${blocks.CoreColumn.fragments.key}
    ...${blocks.CoreImage.fragments.key}
    ...${blocks.CoreParagraph.fragments.key}
    ...${blocks.CoreCode.fragments.key}
    ...${blocks.CoreButtons.fragments.key}
    ...${blocks.CoreButton.fragments.key}
    ...${blocks.CoreQuote.fragments.key}
    ...${blocks.CoreSeparator.fragments.key}
    ...${blocks.CoreList.fragments.key}
    ...${blocks.CoreHeading.fragments.key}
    ...${blocks.CoreCover.fragments.key}
    ...${blocks.CoreTable.fragments.key}
    ...${blocks.AcfCard.fragments.key}
    ...${blocks.AcfAccordion.fragments.key}
    ...${blocks.AcfFeature.fragments.key}
    ...${blocks.AcfBillboard.fragments.key}
    ...${blocks.AcfLeadGenForm.fragments.key}
    ...${blocks.AcfLogoFarm.fragments.key}
    ...${blocks.AcfStyledList.fragments.key}
    ...${blocks.AcfStats.fragments.key}
    ...${blocks.AcfProductComparisonCard.fragments.key}
    ...${blocks.AcfFeatureComparison.fragments.key}
    ...${blocks.AcfTabs.fragments.key}
    ...${blocks.AcfArtDirectionImage.fragments.key}
    ...${blocks.AcfShadow.fragments.key}
    ...${blocks.AcfAppBadges.fragments.key}
    ...${blocks.AcfStripe.fragments.key}
    ...${blocks.AcfCarousel.fragments.key}
    ...${blocks.AcfLottie.fragments.key}
    ...${blocks.AcfExpandableCard.fragments.key}
    ...${blocks.AcfContainer.fragments.key}
    ...${blocks.AcfForm.fragments.key}
    ...${blocks.AcfInput.fragments.key}
    ...${blocks.AcfSelect.fragments.key}
    ...${blocks.AcfFieldset.fragments.key}
    ...${blocks.AcfFilteredList.fragments.key}
    ...${blocks.AcfFilteredListItem.fragments.key}
  }
`;
